import {
    REGISTER_DRIVER_REQUEST,
    REGISTER_DRIVER_SUCCESS,
    REGISTER_DRIVER_FAILURE,
    FETCH_MY_DRIVER_PARTNER_REQUEST,
    FETCH_MY_DRIVER_PARTNER_SUCCESS,
    FETCH_MY_DRIVER_PARTNER_FAILURE,
    REGISTER_DRIVER_PARTNER_REQUEST,
    REGISTER_DRIVER_PARTNER_SUCCESS,
    REGISTER_DRIVER_PARTNER_FAILURE,
    UPDATE_DRIVER_PARTNER_REQUEST,
    UPDATE_DRIVER_PARTNER_SUCCESS,
    UPDATE_DRIVER_PARTNER_FAILURE,
    FETCH_REFERRED_DRIVERS_REQUEST,
    FETCH_REFERRED_DRIVERS_SUCCESS,
    FETCH_REFERRED_DRIVERS_FAILURE,
    FETCH_REFERRAL_MILESTONES_REQUEST,
    FETCH_REFERRAL_MILESTONES_SUCCESS,
    FETCH_REFERRAL_MILESTONES_FAILURE,
    FETCH_PARTNER_PAYOUTS_REQUEST,
    FETCH_PARTNER_PAYOUTS_SUCCESS,
    FETCH_PARTNER_PAYOUTS_FAILURE,
    FETCH_PENDING_COMMISSIONS_REQUEST,
    FETCH_PENDING_COMMISSIONS_SUCCESS,
    FETCH_PENDING_COMMISSIONS_FAILURE,

} from "../actions/types";

const initialState =
    {
        driverPartner:null,
        referredDrivers:[],
        referredDriversMeta:{},
        referralMilestones: [],
        partnerPayouts: [],
        partnerPayoutsPagination: {},
        pendingCommissions: [],
        pendingCommissionsPagination: {},
        loading: false,
        loaded: false, 
        error: null,
        updating:false,
        updateError:null,
        registeringDriver: false,
        registerDriverError: null,
        registeredDriver: null,
    };

const driverPartnerReducer =
    (
        state = initialState,
        action
    ) => {
        switch (
            action.type
        ) {
            case FETCH_MY_DRIVER_PARTNER_REQUEST:
                return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
    };
            case REGISTER_DRIVER_PARTNER_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case FETCH_MY_DRIVER_PARTNER_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    loaded: false,
                    driverPartner:
                        action.payload,
                };

            case REGISTER_DRIVER_PARTNER_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    driverPartner:
                        action.payload,
                };

            case FETCH_MY_DRIVER_PARTNER_FAILURE:
                return {
        ...state,
        loading: false,
        loaded: true, // request finished
        driverPartner: null,
        error: action.payload,
    };
            case REGISTER_DRIVER_PARTNER_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error:
                        action.payload,
                };
            case UPDATE_DRIVER_PARTNER_REQUEST:
                return {
                    ...state,
                    updating: true,
                    updateError: null,
                };

            case UPDATE_DRIVER_PARTNER_SUCCESS:
                return {
                    ...state,
                    updating: false,
                    driverPartner:
                        action.payload,
                };

            case UPDATE_DRIVER_PARTNER_FAILURE:
                return {
                    ...state,
                    updating: false,
                    updateError:
                        action.payload,
                };
            case FETCH_REFERRED_DRIVERS_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case FETCH_REFERRED_DRIVERS_SUCCESS:
                return {
                    ...state,
                    loading: false,

                    referredDrivers:
                        action.payload
                            .data,

                    referredDriversMeta:
                        {
                            total:
                                action
                                    .payload
                                    .total,

                            page:
                                action
                                    .payload
                                    .page,

                            size:
                                action
                                    .payload
                                    .size,

                            pages:
                                action
                                    .payload
                                    .pages,
                        },
                };

            case FETCH_REFERRED_DRIVERS_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error:
                        action.payload,
                };

            case FETCH_REFERRAL_MILESTONES_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case FETCH_REFERRAL_MILESTONES_SUCCESS:
                return {
                    ...state,
                    loading: false,

                    referralMilestones:
                        action.payload,
                };

            case FETCH_REFERRAL_MILESTONES_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error:
                        action.payload,
                };

            case FETCH_PARTNER_PAYOUTS_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case FETCH_PARTNER_PAYOUTS_SUCCESS:
                return {
                    ...state,
                    loading: false,

                    partnerPayouts:
                        action.payload
                            .items,

                    partnerPayoutsPagination:
                        action.payload
                            .pagination,
                };

            case FETCH_PARTNER_PAYOUTS_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error:
                        action.payload,
                };
            case FETCH_PENDING_COMMISSIONS_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: null,
                };

            case FETCH_PENDING_COMMISSIONS_SUCCESS:
                return {
                    ...state,
                    loading: false,

                    pendingCommissions:
                        action.payload.items,

                    pendingCommissionsPagination:
                        action.payload.pagination,
                };

            case FETCH_PENDING_COMMISSIONS_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error:
                        action.payload,
                };
            case REGISTER_DRIVER_REQUEST:
                return {
                    ...state,
                    registeringDriver: true,
                    registerDriverError: null,
                    registeredDriver: null,
                };

            case REGISTER_DRIVER_SUCCESS:
                return {
                    ...state,
                    registeringDriver: false,
                    registeredDriver: action.payload,
                };

            case REGISTER_DRIVER_FAILURE:
                return {
                    ...state,
                    registeringDriver: false,
                    registerDriverError: action.payload,
                };

            default:
                return state;
        }
    };

export default driverPartnerReducer;